// Static imports
import DashIndex from '@/views/member/dash/index.vue'
import DashboardPage from '@/demo/Overview.vue'

export const dash = {
  name: 'dash',
  path: '/dash',
  component: DashIndex,
  redirect: {
    name: 'dashboard'
  },
  props: true,
  meta: {
    layout: 'default',
    isActive: false,
    text: '대시보드',
    icon: 'fa fa-th-large',
    code: 'LV000000'
  },
  children: [
    {
      name: 'dashboard',
      path: '/dash',
      component: DashboardPage,
      meta: {
        menuMember: true,
        text: '대시보드',
        done: true,
        code: 'LV000000'
      }
    }
  ]
}
